import { render, staticRenderFns } from "./sidebar_item.vue?vue&type=template&id=690700e2&scoped=true&"
import script from "./sidebar_item.vue?vue&type=script&lang=js&"
export * from "./sidebar_item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_item.vue?vue&type=style&index=0&id=690700e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690700e2",
  null
  
)

export default component.exports